var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.useLayoutPage && _vm.render && _vm.isLoginSuccess)?_c('Layout'):_vm._e(),(!_vm.useLayoutPage)?_c('router-view'):_vm._e(),_c('IsLoading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }